import React, { useEffect, useRef, useState } from 'react';

import { queryClient } from 'App';
import { useRecoilValue } from 'recoil';

import { ia, iaRa, reShapePractitioners } from 'lib/helpers/utility';
import { usePractitioners } from 'lib/hooks/queries/practitioners/usePractitioners';

import Button from 'components/shared/Buttons/Button';
import Icon from 'components/shared/Icon/Icon';
import Allowed from 'components/shared/Permissions/Allowed';
import { userState } from 'components/state';

import CreateCNConfirm from './CreateCNConfirm';
import ExistingCNConfirm from './ExistingCNConfirm';

const CreateClinicalNoteButton = ({ patientId, widget = false, existingNotes }) => {
  const [note, setNote] = useState(null);
  const [provider, setProvider] = useState(null);
  const [showCreateConfirm, setShowCreateConfirm] = useState(false);
  const [showLoadOrCreateConfirm, setShowLoadOrCreateConfirm] = useState(false);

  const currentUser = useRecoilValue(userState);

  const scrollableDivRef = useRef(null);

  const clinicalNotesExist = queryClient
    .getQueriesData({ queryKey: ['clinicalNotes'] })
    .flatMap(([, data]) => data ?? [])
    .pop();

  const { data: practitionersList } = usePractitioners(
    {},
    {
      select: (data) => reShapePractitioners(iaRa(data.practitioners)),
      enabled: currentUser.kind !== 'practitioner'
    }
  );

  useEffect(() => {
    if (!provider) {
      const currentProvider = iaRa(practitionersList).find(
        (p) => p?.value === currentUser?.user_id
      );
      if (currentProvider) setProvider(currentProvider);
    }
  }, [showCreateConfirm, practitionersList]);

  const clickHandler = () => {
    if (existingNotes || ia(clinicalNotesExist?.clinicalNote)) setShowLoadOrCreateConfirm(true);
    else setShowCreateConfirm(true);
  };

  return (
    <Allowed requiredPermissions="clinical_note.create">
      {!widget ? (
        <Button
          text="Create Clinical Note"
          icon="add-square-mono"
          iconSize={20}
          iconColor="white"
          className="whitespace-nowrap"
          size="small"
          onClick={clickHandler}
        />
      ) : (
        <Icon
          icon="add-square-mono"
          className="cursor-pointer"
          onClick={clickHandler}
          size={22}
          color="primary"
        />
      )}
      <ExistingCNConfirm
        note={note}
        setNote={setNote}
        patientId={patientId}
        setShowCreateConfirm={setShowCreateConfirm}
        showLoadOrCreateConfirm={showLoadOrCreateConfirm}
        setShowLoadOrCreateConfirm={setShowLoadOrCreateConfirm}
        scrollableDivRef={scrollableDivRef}
      />
      <CreateCNConfirm
        showCreateConfirm={showCreateConfirm}
        setShowCreateConfirm={setShowCreateConfirm}
        patientId={patientId}
        provider={provider}
        setProvider={setProvider}
        providers={practitionersList}
      />
    </Allowed>
  );
};

export default CreateClinicalNoteButton;
